const feather = require('feather-icons')

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$('.user_table_filter').on('input change',function () {

    var keyword = $('#user_search_keyword').val();
    var limit = $('#user_show_limit').val();
    window.history.replaceState(null, null, "?page=1&keyword="+ keyword +"&limit=" + limit);
    get_data(keyword, limit);
});

function get_data(keyword, limit) {
    $.ajax({
        type: "GET",
        data: {
            keyword: keyword,
            limit: limit
        },
        success: function (response) {
            $('#users_list').html('');
            var usersTemplateSource = $('#user-detail-template').html();
            var usersTemplate = Handlebars.compile(usersTemplateSource);
            var users = $('#users_list');
            if(response.users.data.length == 0){
                users.addClass('no-result');
            }else{
                users.removeClass('no-result');
            }
            users.html(usersTemplate(response.users.data));
            $('#user_pagination_container').html(response.links);
            feather.replace();
        },
        error: function (error) {

        }
    });

}
